import React from 'react'

interface Props{
    isVideoOpened: boolean,
    VideoSrc: string,
    contextualMenu: boolean
}

interface State{}

class VideoGalleryMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isVideoOpened && this.props.contextualMenu ? "video-gallery-main-mobile fade-in":"video-gallery-main-mobile fade-out"}>
                <iframe 
                    className='iframe-videos' 
                    src={this.props.VideoSrc+"?rel=0?version=3&autoplay=1&controls=0&loop=1&showinfo=0"}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                />
            </div>
        )
    }
}

export default VideoGalleryMobile